// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBIBKeD56gEQK-jYZX6U6LYNfhDy0bQg-A",
  authDomain: "netmedsauth.firebaseapp.com",
  projectId: "netmedsauth",
  storageBucket: "netmedsauth.appspot.com",
  messagingSenderId: "495820235691",
  appId: "1:495820235691:web:99ea3aab1c9e2ec13668ee",
  measurementId: "G-CMZ2WFV63C",
  databaseURL: "https:/netmedsauth-default-rtdb.firebaseio.com",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };
